import { createAction } from '@reduxjs/toolkit'

import { type PostResponse } from '../../types'

export const trackId = createAction<PostResponse>('posts/trackId')
export const untrackId = createAction<string>('posts/untrackId')
